
export class saveorupdateSftpCredential {
  
    userName: string;
    password: string;
    id: string='00000000-0000-0000-0000-000000000000';
}


export class GetSftpBO {
    orderColumn: string = "userName";
    orderType: string = "asc";
    pageitem: number = 10;
    currentpageno: number = 1;
    locationId: string='00000000-0000-0000-0000-000000000000';
    field: string = "userName";
    value: string = "";
    matchCase: boolean = false;
    operator: string = "startswith";
    agencyID: string='00000000-0000-0000-0000-000000000000';
    type: string = "string";
    isActive:boolean=true;
}


export class SftpEventBo
{
    companyList:any=[];
}